export default __webpack_public_path__ + "static/media/scorpionyacht.54dc49ed.png";